import type { Prontuario } from "@/api/db/medico";
import { MedicoLabels } from "@/lib/labels/medico";

import { EvidenceLink } from "./evidence-link";

export function Milestones({
	milestones,
	onOpenEvidence,
}: {
	milestones: Prontuario["milestones"];
	onOpenEvidence?: (evidence: string, origin: string) => void;
}) {
	if (milestones.length === 0) {
		return null;
	}

	return (
		<ol className="flex flex-col gap-2">
			{milestones.map((milestone) => (
				<li key={milestone.id} className="flex items-start gap-3 border-l-2 border-border pl-3">
					<div className="min-w-0">
						<div className="flex items-center gap-2">
							<span className="text-xs uppercase tracking-wide text-muted-foreground">
								{milestone.occurredAt}
							</span>

							<span className="text-xs font-medium text-primary">
								{MedicoLabels.milestoneType[milestone.type]}
							</span>
						</div>

						<p className="text-sm text-foreground">
							{MedicoLabels.milestoneTitle(milestone.title)}
						</p>

						{milestone.detail !== null && (
							<p className="text-xs text-muted-foreground">{milestone.detail}</p>
						)}
					</div>

					<EvidenceLink
						evidence={milestone.evidence}
						onOpen={
							onOpenEvidence === undefined
								? undefined
								: (evidence) => onOpenEvidence(evidence, milestone.origin)
						}
					/>
				</li>
			))}
		</ol>
	);
}
